import { useQuery } from 'react-query';
import { smartbiz } from './ApiClient';

export async function getChatBotJWT() {
  const response = (
    await smartbiz.get(`/support/token`)
  )?.data;
  return response;
}
  
  function useGetChatBotJWTQuery() {
    const chatBotJWTResponse = useQuery('chatBotJwtToken', getChatBotJWT, {
      refetchOnWindowFocus: false,
      enabled: false,
    });
  
    return chatBotJWTResponse;
  }
  
  export default useGetChatBotJWTQuery;